// extracted by mini-css-extract-plugin
export default {"Recruitment":"Recruitment_Recruitment__54Gv7","RecruitmentBG":"Recruitment_RecruitmentBG__Lo047","Text":"Recruitment_Text__F28Sj","TextImgs":"Recruitment_TextImgs__7oKsv"};